import throttle from 'lodash/throttle';

export default class ScrollEvents {
  constructor() {
    this.bindEvents();
  }

  bindEvents() {
    window.addEventListener('scroll', throttle(this.toggleBodyClass, 100));
  }

  toggleBodyClass() {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    document.body.classList.toggle('is-scrolled', scrollTop > 600);
  }

};
